module.exports = __webpack_public_path__ + "static/media/move.579e4cdb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/move.svg
// module id = 651
// module chunks = 0